<template>
  <section class="slider-shell">
    <div ref="swiperContainer" class="swiper-container slider-swiper">
      <div class="swiper-wrapper">
        <article
          v-for="(image, index) in images"
          :key="index"
          class="swiper-slide slide-card"
        >
          <div
            class="slide-media"
            :style="{
              '--hero-ratio-mobile-slide':
                image.mobileRatio || 'var(--hero-ratio-mobile)',
              '--hero-ratio-mobile-sm-slide':
                image.mobileRatioSm ||
                image.mobileRatio ||
                'var(--hero-ratio-mobile-sm)'
            }"
          >
            <picture class="slide-picture">
              <source
                v-if="image.mobileSrc"
                media="(max-width: 767.98px)"
                :srcset="resolveImageSrc(image.mobileSrc)"
              />
              <img
                :src="resolveImageSrc(image.src)"
                :alt="image.title"
                class="img-slider"
                :style="{
                  '--img-position': image.position,
                  '--img-position-mobile':
                    image.mobilePosition || image.position,
                  '--img-fit-mobile': image.mobileFit || 'cover',
                  '--img-fit-mobile-sm':
                    image.mobileFitSm || image.mobileFit || 'cover',
                  '--img-scale-mobile': image.mobileScale || 1.04,
                  '--img-scale-mobile-sm':
                    image.mobileScaleSm || image.mobileScale || 1.08
                }"
              />
            </picture>
            <div class="slide-overlay"></div>
            <div class="slide-accent"></div>
            <div class="slide-copy">
              <p class="slide-eyebrow">{{ image.eyebrow }}</p>
              <h4>{{ image.title }}</h4>
              <p class="slide-description">
                {{ image.description }}
              </p>
              <router-link :to="image.link" class="slide-cta">
                {{ image.cta }}
              </router-link>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="slide-controls" v-if="images.length > 1">
      <div ref="pagination" class="slider-pagination"></div>
      <div class="slider-actions">
        <button
          type="button"
          class="slider-action"
          @click="showPrev"
          aria-label="Previous slide"
        >
          <span aria-hidden="true">&lt;</span>
        </button>
        <button
          type="button"
          class="slider-action"
          @click="showNext"
          aria-label="Next slide"
        >
          <span aria-hidden="true">&gt;</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.esm.js";
import "swiper/swiper-bundle.min.css";

export default {
  name: "Slider",
  data() {
    return {
      swiper: null,
      settings: {
        speed: 900,
        autoplayDelay: 3600
      },
      images: [
        {
          src: "banner-1.jpg",
          mobileSrc: "banner-1-mobile.png",
          position: "50% 46%",
          mobilePosition: "78% 44%",
          mobileScale: 1.12,
          mobileScaleSm: 1.16,
          eyebrow: "Asuransi Harta Benda",
          title: "Perlindungan syariah untuk aset dan kepentingan usaha",
          description:
            "Memberikan perlindungan atas risiko pada harta benda dan aset usaha dengan prinsip syariah yang transparan dan tepercaya.",
          cta: "Lihat Produk",
          link: "/produk"
        },
        {
          src: "banner-safari.jpeg",
          mobileSrc: "banners-safari-mobile.png",
          position: "52% 50%",
          mobilePosition: "50% 50%",
          mobileFit: "contain",
          mobileScale: 1,
          mobileScaleSm: 1,
          mobileRatio: "4 / 3",
          mobileRatioSm: "4 / 3",
          mobileHeight: "clamp(300px, 78vw, 360px)",
          mobileHeightSm: "clamp(285px, 84vw, 335px)",
          eyebrow: "Asuransi Perjalanan",
          title:
            "Perjalanan lebih tenang dengan manfaat perlindungan yang jelas",
          description:
            "Melindungi perjalanan Anda dari berbagai risiko selama bepergian, dengan manfaat yang ringkas dan proses layanan yang praktis.",
          cta: "Lihat Manfaat",
          link: "/produk-detail/takaful-safari"
        },
        {
          src: "banner-medis.jpeg",
          mobileSrc: "banner-medis-mobile.png",
          position: "50% 48%",
          mobilePosition: "50% 50%",
          mobileFit: "contain",
          mobileScale: 1,
          mobileScaleSm: 1,
          mobileRatio: "16 / 9",
          mobileRatioSm: "16 / 9",
          mobileHeight: "clamp(280px, 62vw, 340px)",
          mobileHeightSm: "clamp(260px, 68vw, 310px)",
          eyebrow: "Tanggung Gugat Profesi",
          title:
            "Perlindungan tanggung gugat untuk tenaga medis dan profesional",
          description:
            "Dirancang untuk membantu melindungi tenaga profesional dari risiko tanggung gugat yang timbul dalam menjalankan pekerjaan.",
          cta: "Pelajari Produk",
          link: "/produk-detail/takaful-professional-liability"
        },
        {
          src: "banner-pa.jpeg",
          mobileSrc: "banners-pa-mobile.png",
          position: "54% 46%",
          mobilePosition: "74% 38%",
          mobileScale: 1.14,
          mobileScaleSm: 1.18,
          eyebrow: "Kecelakaan Diri",
          title:
            "Perlindungan kecelakaan diri untuk aktivitas dan masa depan anak",
          description:
            "Memberikan perlindungan atas risiko kecelakaan diri dengan manfaat yang relevan untuk aktivitas harian dan kebutuhan pendidikan.",
          cta: "Lihat Detail",
          link: "/produk-detail/takaful-pa-siswa"
        }
      ]
    };
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    this.destroySwiper();
  },
  methods: {
    resolveImageSrc(path) {
      return require(`@/assets/${path}`);
    },
    initSwiper() {
      this.$nextTick(() => {
        this.destroySwiper();

        this.swiper = new Swiper(this.$refs.swiperContainer, {
          loop: this.images.length > 1,
          speed: this.settings.speed,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          autoplay:
            this.images.length > 1
              ? {
                  delay: this.settings.autoplayDelay,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false
                }
              : false,
          pagination: {
            el: this.$refs.pagination,
            clickable: true
          },
          observer: true,
          observeParents: true,
          a11y: {
            enabled: true
          }
        });
      });
    },
    destroySwiper() {
      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
    },
    showPrev() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
    },
    showNext() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
    }
  }
};
</script>

<style scoped>
.slider-shell {
  --hero-height-desktop: clamp(400px, 25.72vw, 495px);
  --hero-height-tablet: 400px;
  --hero-height-mobile: clamp(320px, 76vw, 390px);
  --hero-height-mobile-sm: clamp(300px, 88vw, 350px);
  --hero-ratio-desktop: 4594 / 1182;
  --hero-ratio-mobile: 16 / 10;
  --hero-ratio-mobile-sm: 16 / 11;
  position: relative;
  left: 50%;
  width: 100vw;
  max-width: 100vw;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: hidden;
  background: #0b1622;
}

.slider-swiper {
  overflow: hidden;
  border-radius: 0;
}

.slide-card {
  width: 100%;
}

.slide-media {
  position: relative;
  width: 100%;
  height: var(--hero-height-desktop);
  aspect-ratio: var(--hero-ratio-desktop);
  overflow: hidden;
  background: #0f1e2d;
}

.slide-picture {
  display: block;
  width: 100%;
  height: 100%;
}

.img-slider {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: var(--img-position, center center);
  transform: scale(1);
  transform-origin: center center;
  animation: slider-pan 14s ease-in-out infinite alternate;
}

.slide-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
      90deg,
      rgba(7, 18, 31, 0.88) 0%,
      rgba(7, 18, 31, 0.55) 38%,
      rgba(7, 18, 31, 0.18) 70%,
      rgba(7, 18, 31, 0.08) 100%
    ),
    linear-gradient(
      180deg,
      rgba(7, 18, 31, 0.12) 0%,
      rgba(7, 18, 31, 0.22) 52%,
      rgba(7, 18, 31, 0.78) 100%
    );
}

.slide-accent {
  position: absolute;
  left: 0;
  top: 72px;
  width: 6px;
  height: 104px;
  background: linear-gradient(180deg, #ef4444 0%, #f59e0b 100%);
  z-index: 1;
}

.slide-copy {
  position: absolute;
  left: 48px;
  top: 48px;
  z-index: 1;
  width: min(440px, calc(100% - 96px));
  padding: 22px 24px 20px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(
    180deg,
    rgba(7, 18, 31, 0.5),
    rgba(7, 18, 31, 0.66)
  );
  backdrop-filter: blur(4px);
}

.slide-eyebrow {
  margin: 0 0 8px;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.9;
}

.slide-copy h4 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.3rem, 2vw, 2.1rem);
  line-height: 1.18;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  max-width: none;
}

.slide-description {
  margin: 14px 0 0;
  max-width: none;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.85rem;
  line-height: 1.55;
}

.slide-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 148px;
  margin-top: 22px;
  padding: 12px 22px;
  border-radius: 999px;
  background: #ffffff;
  color: #0b1622;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-decoration: none;
  text-transform: uppercase;
  transition: transform 0.25s ease, background 0.25s ease, color 0.25s ease;
}

.slide-cta:hover {
  transform: translateY(-2px);
  background: #f3f4f6;
}

.slide-controls {
  position: absolute;
  left: 48px;
  right: 48px;
  bottom: 22px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.slider-pagination {
  display: inline-flex;
  align-items: center;
}

::v-deep .slider-pagination .swiper-pagination-bullet {
  width: 34px;
  height: 4px;
  margin: 0 6px 0 0 !important;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.34);
  opacity: 1;
}

::v-deep .slider-pagination .swiper-pagination-bullet-active {
  background: #ffffff;
}

.slider-actions {
  display: inline-flex;
  gap: 10px;
}

.slider-action {
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.25s ease, background 0.25s ease,
    border-color 0.25s ease;
}

.slider-action:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.54);
}

@keyframes slider-pan {
  0% {
    transform: scale(1) translate3d(0, 0, 0);
  }

  100% {
    transform: scale(1.08) translate3d(-1.5%, -1%, 0);
  }
}

@media only screen and (max-width: 767.98px) {
  .slider-shell,
  .slider-swiper,
  .slide-card,
  .slide-media,
  .slide-picture,
  .img-slider {
    width: 100%;
    max-width: 100%;
  }

  .slide-picture {
    display: block;
    height: auto;
    background: transparent;
  }

  .slide-media {
    height: auto;
    aspect-ratio: auto;
    overflow: visible;
  }

  .img-slider {
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: var(
      --img-position-mobile,
      var(--img-position, center center)
    );
    transform: none;
    animation: none;
  }

  .slide-overlay {
    display: none;
  }

  .slide-accent {
    display: none;
  }

  .slide-copy {
    display: none;
  }

  .slide-eyebrow {
    display: none;
  }

  .slide-copy h4 {
    max-width: none;
    display: none;
  }

  .slide-description {
    max-width: 100%;
    margin-top: 0;
    color: rgba(255, 255, 255, 0.62);
    font-size: 0.72rem;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .slide-cta {
    min-width: 0;
    margin-top: 16px;
    padding: 10px 20px;
    font-size: 0.68rem;
  }

  .slide-controls {
    display: none;
  }
}

@media only screen and (max-width: 420px) {
  .slide-media {
    height: auto;
    aspect-ratio: auto;
  }

  .img-slider {
    height: auto;
    object-fit: contain;
    transform: none;
  }

  .slide-copy {
    display: none;
  }

  .slide-copy h4 {
    max-width: 100%;
    display: none;
  }

  .slide-description {
    max-width: 100%;
    margin-top: 0;
    color: rgba(255, 255, 255, 0.58);
    font-size: 0.7rem;
    -webkit-line-clamp: 2;
  }
}
</style>
